import { gql } from '@apollo/client';

export const fetchProductsForTransactionAccount = gql`
  query fetchProductsForTransactionAccount($id: ID!) {
    transactionAccount(id: $id) {
      id
      products {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          transactionAccountNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
        }
      }
    }
  }
`;
